import { useEffect, useState } from "react";
import { api, fmtDate, fmtMoney } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SectionTitle, StatCard } from "@/admin/ui";

export function AdminOverview() {
  const { site } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="h-64 rounded-2xl bg-slate-900/60 animate-pulse" />;
  return (
    <div>
      <SectionTitle eyebrow="Kontrol Merkezi" title="Genel Bakış" />
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4">
        <StatCard label="Kullanıcı" value={d.users} testId="stat-users" />
        <StatCard label="Bekleyen Ödeme" value={d.pending_payments} tone="amber" testId="stat-pending" />
        <StatCard label="Onaylı Satış" value={d.approved_payments} tone="green" testId="stat-approved" />
        <StatCard label="Toplam Gelir" value={fmtMoney(d.revenue, site?.currency)} tone="green" testId="stat-revenue" />
        <StatCard label="Banlı" value={d.banned} tone="red" testId="stat-banned" />
        <StatCard label="Bilgi Paketi" value={d.infos} testId="stat-infos" />
        <StatCard label="Genel Sohbet Mesajı" value={d.public_messages} testId="stat-messages" />
        <StatCard label="Açık Bildirim" value={d.open_reports} tone="red" testId="stat-reports" />
        <StatCard label="Okunmamış İletişim" value={d.unread_contacts} tone="amber" testId="stat-contacts" />
        <StatCard label="Reddedilen Ödeme" value={d.rejected_payments} tone="red" testId="stat-rejected" />
      </div>
      <div className="mt-10">
        <p className="font-mono-cx text-[10px] uppercase tracking-[0.3em] text-cyan-400 mb-3">Son Kayıtlar</p>
        <div className="cx-glass rounded-2xl divide-y divide-slate-800/70">
          {d.recent_users.length === 0 && <p className="p-6 text-sm text-slate-500">Henüz kullanıcı yok.</p>}
          {d.recent_users.map((u) => (
            <div key={u.id} className="px-5 py-3.5 flex items-center justify-between text-sm">
              <span className="font-semibold text-slate-100">{u.username}</span>
              <span className="font-mono-cx text-xs text-slate-500">{u.last_ip || "-"}</span>
              <span className="text-xs text-slate-500">{fmtDate(u.created_at)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
